/* eslint-disable arrow-body-style */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import i18n from 'i18n-react';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';

import ContentHeader from 'components/ContentHeader';
import Progress from 'components/Progress';

import APIHandler from 'config/APIHandler';
import StorageHandler from 'config/StorageHandler';

import useIncentiveLink from 'hooks/useIncentiveLink';

import { baseAppId, storageKeys } from 'settings';

const TrainingGridAccordion = ({
  diplomaProgressRate,
  opened,
  foundationalLinks,
  specialistLinks,
  itineraryLinks = [],
  extraLearningLinks,
}) => {
  const [microAppId, setMicroAppId] = useState(0);
  const [incentiveLink, incentiveProgress] = useIncentiveLink(microAppId);


  useEffect(() => {
    const getIncentivesData = () => {
      try {
        StorageHandler.load(storageKeys.lang).then(async (lang) => {
          const result = await APIHandler.getContests(baseAppId, {
            currentDate: new Date().toISOString(),
            marketFilter: [{ id: lang.code.toUpperCase() }],
          });
          if (Array.isArray(result) && result.length > 0) {
            setMicroAppId(result[0].micro_app_id);
          }
        });
      } catch (error) {
        setMicroAppId(0);
      }
    };
    getIncentivesData();
  }, []);

  return (
    <React.Fragment>
      {/* <Modal show={showDiploma} onHide={handleDiplomaClose} bgClose>
        <Diploma appId={appId} firstName={firstName} lastName={lastName} email={email} />
      </Modal> */}
      <Accordion preExpanded={opened} key={opened}>
        <div>
          <div className="trainingGrid">
            {foundationalLinks.length > 0 && (
              <AccordionItem uuid="foundational">
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <div className="subheader bronzeHeader">
                      <ContentHeader
                        header={i18n.translate('trainingScreens.essential')}
                        subtitle={i18n.translate('trainingScreens.essentialSub')}
                      >
                        <div
                          className={clsx('container__Progress', {
                            'container__Progress--complete': diplomaProgressRate === 100,
                          })}
                        >
                          <div className="container__progressBar">
                            <Progress id="progress" value={diplomaProgressRate} />
                            {diplomaProgressRate !== 100 && (
                              <h6 className="progressText">
                                {diplomaProgressRate}
                                {i18n.translate('trainingScreens.percentageComplete')}
                              </h6>
                            )}
                            {diplomaProgressRate === 100 && (
                              <h6 className="progressText">{i18n.translate('trainingScreens.completedBase')}</h6>
                            )}
                          </div>
                          {/* {renderDiplomaLink()} */}
                          <style>{'\
                            #openWidget { display: block; } '}</style>
                        </div>
                      </ContentHeader>

                      <AccordionItemState>
                        {({ expanded }) =>
                          !expanded ? (
                            <div className="arrow">
                              <FontAwesomeIcon icon={['fas', 'chevron-down']} />
                            </div>
                          ) : (
                            <div className="arrow">
                              <FontAwesomeIcon icon={['fas', 'chevron-up']} />
                            </div>
                          )
                        }
                      </AccordionItemState>
                    </div>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="flexer">
                    <div className="trainingGrid trainingGrid--main trainingGrid--8-col">{foundationalLinks} </div>
                  </div>
                </AccordionItemPanel>
              </AccordionItem>
            )}

            {specialistLinks.length > 0 && (
              <AccordionItem uuid="specialized">
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <div className="subheader sub silverHeader">
                      <ContentHeader
                        header={i18n.translate('contentHeaders.subtrainings')}
                        subtitle={i18n.translate('pageDescriptions.subtrainings')}
                      >
                        <div
                          className={clsx('container__Progress', {
                            'container__Progress--complete': diplomaProgressRate === 100,
                          })}
                        >
                          <style>{'\
                            #openWidget { display: block; } '}</style>
                        </div>
                      </ContentHeader>
                      <AccordionItemState>
                        {({ expanded }) =>
                          !expanded ? (
                            <div className="arrow">
                              <FontAwesomeIcon icon={['fas', 'chevron-down']} />
                            </div>
                          ) : (
                            <div className="arrow">
                              <FontAwesomeIcon icon={['fas', 'chevron-up']} />
                            </div>
                          )
                        }
                      </AccordionItemState>
                    </div>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <div className="trainingGrid sub1">{specialistLinks}</div>
                </AccordionItemPanel>
              </AccordionItem>
            )}
          </div>
          {itineraryLinks.length > 0 && (
            <AccordionItem uuid="itineraries">
              <div className="trainingGrid subApps">
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <div className="subheader goldHeader">
                      <ContentHeader
                        header={i18n.translate('contentHeaders.itineraries')}
                        subtitle={i18n.translate('pageDescriptions.itineraries')}
                      />
                      <AccordionItemState>
                        {({ expanded }) =>
                          !expanded ? (
                            <div className="arrow">
                              <FontAwesomeIcon icon={['fas', 'chevron-down']} />
                            </div>
                          ) : (
                            <div className="arrow">
                              <FontAwesomeIcon icon={['fas', 'chevron-up']} />
                            </div>
                          )
                        }
                      </AccordionItemState>
                    </div>
                  </AccordionItemButton>
                </AccordionItemHeading>
              </div>
              <AccordionItemPanel>
                <div className="flexer">
                  <div className="trainingGrid trainingGrid--extra trainingGrid--6-col">{itineraryLinks}</div>
                </div>
              </AccordionItemPanel>
            </AccordionItem>
          )}
          {extraLearningLinks.length > 0 && (
            <AccordionItem uuid="extra">
              <div className="trainingGrid subApps">
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <div className="subheader goldHeader">
                      <ContentHeader
                        header={i18n.translate('contentHeaders.subapps')}
                        subtitle={i18n.translate('pageDescriptions.subapps')}
                      />
                      <AccordionItemState>
                        {({ expanded }) =>
                          !expanded ? (
                            <div className="arrow">
                              <FontAwesomeIcon icon={['fas', 'chevron-down']} />
                            </div>
                          ) : (
                            <div className="arrow">
                              <FontAwesomeIcon icon={['fas', 'chevron-up']} />
                            </div>
                          )
                        }
                      </AccordionItemState>
                    </div>
                  </AccordionItemButton>
                </AccordionItemHeading>
              </div>
              <AccordionItemPanel>
                <div className="flexer">
                  {/* <div className="trainingGrid sub2">{extraLearningLinks}</div> */}
                  <div className="trainingGrid trainingGrid--extra trainingGrid--6-col">
                    {extraLearningLinks}
                    {/* {microAppId > 0 && (
                      <a
                        href={incentiveLink}
                        className="trainingCard__Animated trainingGrid__training-card--extra incentiveCard"
                      >
                        <div>
                          <FontAwesomeIcon icon={['fas', 'treasure-chest']} />
                          <h4>{i18n.translate('trainingScreens.partnerBadgeIncentive')}</h4>

                          {incentiveProgress === 0 && (
                            <button type="button">{i18n.translate('trainingScreens.start')}</button>
                          )}
                          {incentiveProgress > 0 && incentiveProgress < 100 && (
                            <button type="button">{i18n.translate('trainingScreens.continue')}</button>
                          )}
                          {incentiveProgress > 100 && (
                            <button type="button">{i18n.translate('trainingScreens.completed')}</button>
                          )}
                        </div>
                      </a>
                    )} */}
                  </div>
                </div>
              </AccordionItemPanel>
            </AccordionItem>
          )}
        </div>
      </Accordion>
    </React.Fragment>
  );
};

export default TrainingGridAccordion;

TrainingGridAccordion.propTypes = {
  diplomaProgressRate: PropTypes.number.isRequired,
  opened: PropTypes.arrayOf(PropTypes.string).isRequired,
  foundationalLinks: PropTypes.arrayOf(PropTypes.element).isRequired,
  specialistLinks: PropTypes.arrayOf(PropTypes.element).isRequired,
  itineraryLinks: PropTypes.arrayOf(PropTypes.element),
  extraLearningLinks: PropTypes.arrayOf(PropTypes.element).isRequired,
};
